import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelloWorldPresComponent } from './hello-world-pres.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [HelloWorldPresComponent],
  exports: [HelloWorldPresComponent],
  imports: [CommonModule, TranslateModule],
})
export class HelloWorldPresModule {}
